<span *ngIf="formattedPoint"
  class="value-wrapper"
  [matTooltip]="formattedPoint">
  {{ formattedPoint }}
</span>
